import { getElementControls } from "core-integration/src/store/elements/reducers";
import { IElement } from "core-integration/src/store/elements/types";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getStatDetails, getStatNames } from "../../utils/stats";
import { FieldWrap, SelectField } from "../FieldRenderers";

interface ISortOption {
  label: string;
  value: keyof IElement;
}

type Props = {
  handleSortChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  sortOptions?: ISortOption[];
} & WithTranslation;

const ElementSort: React.FC<Props> = ({ handleSortChange, sortOptions, t }) => {
  const controls = useSelector(getElementControls);

  const defaultSortOptions: ISortOption[] = getStatNames(t).map((s) => ({
    label: getStatDetails(s, t)!.label,
    value: s,
  }));

  const options = sortOptions ?? defaultSortOptions;

  return (
    <FieldWrap>
      <SelectField
        id="sort"
        name="sort"
        label={t("sortedBy", "Sorted by")}
        value={controls.sort}
        onChange={handleSortChange}
        required={false}
      >
        {options.map((o) => (
          <option
            key={o.value}
            value={o.value}
            aria-selected={controls.filter === o.value}
          >
            {o.label}
          </option>
        ))}
      </SelectField>
    </FieldWrap>
  );
};

export default withTranslation()(ElementSort);
